import React from 'react';

const AnimatedLoader = (props) => {
  const { style, guttered, rightGutter, leftGutter, topGutter, bottomGutter, gutter = 10 } = props;

  let elemStyle = style ? { ...style } : {};
  if (rightGutter || guttered) {
    elemStyle.marginRight = `${gutter}px`;
  }

  if (bottomGutter || guttered) {
    elemStyle.marginBottom = `${gutter}px`;
  }

  if (leftGutter || guttered) {
    elemStyle.marginLeft = `${gutter}px`;
  }

  if (topGutter || guttered) {
    elemStyle.marginTop = `${gutter}px`;
  }

  return (
    <div className={'loadingOverlay ' + (true ? 'active' : '')}>
      <div className={`loadingElementContainer ${props.small ? 'small' : ''}`}>
        <div className="loadingElementPill" />
        <div className="loadingElementInnerBorder" />
      </div>
    </div>
  );
};

export default AnimatedLoader;
